import React, { useState, useEffect } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashNav from "../../Components/DashNav/DashNav";
import Gbtn from "../../Components/buttons/Gbtn";
import LoadingSpinner from "../../Components/LoadingSpinner/LoadingSpinner";
import AuthorsSVG from "../../Components/SVGS/AuthorsSVG";
import InputField from "../../Components/InputField/InputField";
import { deleteAuthor, deleteTeam, postAuthor, postTeam } from "../../api";
import Modal from "react-modal";
import { RxCross2 } from "react-icons/rx";
import "animate.css";
import { MdPeople } from "react-icons/md";
import RichTextarea from "../../Components/RichTextArea";

export default function TeamAddEdit({ isEdit, isDelete }) {
    const icon = () => {
        return <MdPeople size="26" fill="#DF2F35" />;
    };

    const location = useLocation();
    const prevData =
        location.state && location.state ? location.state.editData : null;
    const page = location.state && location.state ? location.state.page : null;

    let baseUrl = process.env.REACT_APP_BASE_URL;
    const [isLoading, setIsLoading] = useState(false);
    const [profileImage, setProfileImage] = useState("");
    const [editImage, setEditImage] = useState("");
    const [errMsg, setErrMsg] = useState("");
    const [err, setErr] = useState(false);
    const [modalIsOpen, setModalIsOpen] = useState(false);
    const [imageErr, setImageErr] = useState(false);
    const [nameErr, setNameErr] = useState(false);
    const [designationErr, setDesignationErr] = useState(false);
    const [updatedData, setUpdatedData] = useState({
        id: prevData ? prevData.id : 0,
        name: prevData ? prevData.name : "",
        image_path: prevData ? prevData.image_path : "",
        designation: prevData ? prevData.designation : "",
        description: prevData ? prevData.description : "",
    });

    // fetching initial data
    useEffect(() => {
        window.scrollTo({
            top: 0,
            behavior: "smooth",
        });
        setEditImage(prevData?.image_path ? prevData?.image_path : "");
    }, []);

    useEffect(() => {
        Modal.setAppElement("#root");
    }, []);

    const navigate = useNavigate();

    const saveOnclick = () => {
        if (!updatedData.name) setNameErr(true);
        else {
            setIsLoading(true);
            setErr(false);
            let data = new FormData();
            data.append("id", updatedData.id);
            data.append("name", updatedData.name);
            data.append("designation", updatedData.designation);
            data.append("description", updatedData.description);
            if (typeof profileImage == "string") data.append("image_path", editImage);
            else data.append("image", profileImage);

            postTeam(data)
                .then(({ data }) => {
                    setIsLoading(false);
                    if (data.error_code == 0 || data.error_code == 1) {
                        navigate("/dashboard/team", {
                            state: { page: page },
                        });
                    } else {
                        setErr(true);
                        setErrMsg(data.message);
                    }
                })
                .catch((err) => {
                    setIsLoading(false);
                    setErr(true);
                    setErrMsg("Some error occured. Please check your network connection.");
                });
        }
    };

    const deleteOnclick = () => {
        setModalIsOpen(true);
    };
    const deleteClick = () => {
        let obj = {
            id: prevData ? prevData.id : null,
        };
        deleteTeam(obj)
            .then(({ data }) => {
                setErr(false);
                setIsLoading(true);
                if (data.success) {
                    setModalIsOpen(false);
                    setIsLoading(false);
                    navigate("/dashboard/team", {
                        state: { page: page },
                    });
                } else {
                    setErr(true);
                    setErrMsg(data.message);
                }
            })
            .catch((Err) => {
                console.log("Delete role Error: ", Err);
                setErrMsg(err.message);
                setModalIsOpen(false);
                setErr(true);
                setIsLoading(false);
            });
    };

    const onSelectImage = (img) => {
        if (
            img.type.includes("png") ||
            img.type.includes("jpg") ||
            img.type.includes("jpeg")
        ) {
            setProfileImage(img);
            setImageErr(false);
            setEditImage("");
        } else {
            alert("Invalid File!");
        }
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setUpdatedData({ ...updatedData, [name]: value });
    };

    const handleImageErr = () => {
        setImageErr(true);
    };

    return (
        <>
            <Modal
                isOpen={modalIsOpen}
                className="deleteModal animate__animated animate__zoomIn"
                style={{ display: "flex" }}
            >
                {isLoading ? (
                    <LoadingSpinner />
                ) : (
                    <>
                        <div
                            className="delClient-cross"
                            onClick={(e) => {
                                setModalIsOpen(false);
                            }}
                        >
                            <RxCross2 color="white" size={"20"} />
                        </div>
                        <>
                            <h3 style={{ color: "white", marginBottom: "60px" }}>
                                Are you sure you want to delete?
                            </h3>

                            <Gbtn
                                text="Delete"
                                color="#EE282E"
                                radius="6px"
                                width="40%"
                                func={deleteClick}
                            />
                        </>
                    </>
                )}
            </Modal>

            <div className="mainDashView">
                <div>
                    <DashNav svg={icon} DashboardNavText={"Team"} />
                </div>
                <div className="dashPanel" style={{ position: "relative" }}>
                    <>
                        <div className="ar-dashpanel">
                            <h4
                                style={{
                                    display: err ? "flex" : "none",
                                    justifyContent: "center",
                                    color: "red",
                                    position: "absolute",
                                    top: "0",
                                    width: "90%",
                                }}
                            >
                                <p>Error! {errMsg}.</p>
                            </h4>
                            {isLoading ? (
                                <div
                                    style={{
                                        display: "flex",
                                        justifyContent: "center",
                                        width: "100%",
                                    }}
                                >
                                    <LoadingSpinner />
                                </div>
                            ) : (
                                <div>
                                    <div>
                                        <div className="ae-formFields">
                                            <div className="ae-inputField">
                                                <InputField
                                                    name={"name"}
                                                    isErr={nameErr}
                                                    errorMsg="Name is required"
                                                    required={true}
                                                    value={updatedData ? updatedData.name : null}
                                                    onChange={(e) => {
                                                        setNameErr(false);
                                                        handleChange(e);
                                                    }}
                                                    placeholder={"Name"}
                                                    radius="5px"
                                                />
                                            </div>
                                            <div className="ae-inputField">
                                                <InputField
                                                    name={"designation"}
                                                    isErr={designationErr}
                                                    errorMsg="Designation is required"
                                                    required={true}
                                                    value={updatedData ? updatedData.designation : null}
                                                    onChange={(e) => {
                                                        setDesignationErr(false);
                                                        handleChange(e);
                                                    }}
                                                    placeholder={"Designation"}
                                                    radius="5px"
                                                />
                                            </div>
                                        </div>

                                        <div style={{ position: "relative", marginBottom: "14px" }}>
                                            <div
                                                className="ae-formFields"
                                                style={{
                                                    width: "80%",
                                                    marginTop: "3em",
                                                    marginBottom: "0px",
                                                }}
                                            >
                                                <RichTextarea
                                                    name={"Description"}
                                                    // isErr={detDescriptionErr}
                                                    errorMsg="Field is required"
                                                    value={updatedData.description}
                                                    onChange={(e) => {
                                                        setUpdatedData({
                                                            ...updatedData,
                                                            description: e,
                                                        });
                                                    }}
                                                    placeholder="Detailed Description"
                                                />
                                            </div>
                                            {/* <div
                                                className="err-txt"
                                                style={{
                                                    display: detDescriptionErr ? "flex" : "none",
                                                    position: "absolute",
                                                    width: "150px",
                                                }}
                                            >
                                                Description is required
                                            </div> */}
                                        </div>
                                    </div>

                                    <div className="if-txt" style={{ marginTop: "40px" }}>
                                        Add Image
                                    </div>
                                    <div className="Add_Client_Image_container">
                                        {editImage || profileImage ?
                                            <div className="cross_icon_img" onClick={() => { setEditImage(''); setProfileImage('') }}>
                                                <RxCross2 size={16} />
                                            </div> : null}
                                        <label className="changeimage-label">
                                            {editImage || profileImage ? (
                                                <>
                                                    <img
                                                        src={
                                                            editImage
                                                                ? baseUrl + editImage
                                                                : URL.createObjectURL(profileImage)
                                                        }
                                                        onError={handleImageErr}
                                                        alt="cp"
                                                        height="120px"
                                                        width="120px"
                                                        className="add-image-Style"
                                                    />
                                                    <div>
                                                        <input
                                                            type="file"
                                                            className="formuploadimage_input"
                                                            accept=".png, .jpg, jpeg"
                                                            onChange={(e) => onSelectImage(e.target.files[0])}
                                                            onClick={(event) =>
                                                                (event.currentTarget.value = null)
                                                            }
                                                        />
                                                    </div>
                                                </>
                                            ) : (
                                                <div className="AddimageBtn">
                                                    <span className="cam_Image_upload">+</span>
                                                    <div>
                                                        <input
                                                            type="file"
                                                            className="formuploadimage_input"
                                                            accept=".png, .jpg, jpeg"
                                                            onChange={(e) => onSelectImage(e.target.files[0])}
                                                            onClick={(event) =>
                                                                (event.currentTarget.value = null)
                                                            }
                                                        />
                                                    </div>
                                                </div>
                                            )}
                                        </label>
                                    </div>
                                </div>
                            )}
                            <div className="addEdit-btns">
                                <div className="ev-btnAdd ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Update" : isDelete ? "Delete" : "Add"}
                                        func={isDelete ? deleteOnclick : saveOnclick}
                                        disabled={isLoading}
                                        color="#DF2F35"
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                                <div className="ev-btnDel ev-btn">
                                    <Gbtn
                                        text={isEdit ? "Discard" : "Back"}
                                        color="#0061B1"
                                        func={() =>
                                            navigate("/dashboard/team", {
                                                state: { page: page },
                                            })
                                        }
                                        radius="5px"
                                        width="150px"
                                    />
                                </div>
                            </div>
                        </div>
                    </>
                </div>
            </div>
        </>
    );
}


